import React, { forwardRef, Ref, useMemo } from 'react'

import { getUserDisplayName } from '@surglogs/models'

import { SelectLegacy, SelectLegacyProps } from '@surglogs-app/ui'

import { useTranslation } from '../../services'

import type { UserItem } from './types'

type SignatureGroupUserListFieldProps = SelectLegacyProps & {
  allowOther: boolean
  usersAllowedToSign: UserItem[]
  otherUserItem?: UserItem
}

export const SignatureGroupUserListField = forwardRef(
  (
    {
      allowOther,
      usersAllowedToSign,
      otherUserItem,
      ...rest
    }: SignatureGroupUserListFieldProps,
    ref: Ref<HTMLInputElement>,
  ) => {
    const { t } = useTranslation()

    const filteredUsers = useMemo(() => {
      const activeUsers = [...usersAllowedToSign]

      if (allowOther && otherUserItem) {
        activeUsers?.push(otherUserItem)
      }

      return activeUsers
    }, [usersAllowedToSign, allowOther, otherUserItem])

    const getLabelKey = (user: UserItem): string => {
      if (user.id === otherUserItem?.id) {
        return t('otherLabel')
      }

      return getUserDisplayName(user)
    }

    return (
      <SelectLegacy
        {...{
          ...rest,
          data: filteredUsers,
          labelKey: getLabelKey,
          placeholder: t('selectUserPlaceholder'),
          ref,
        }}
      />
    )
  },
)
